<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="35rem"
    persistent
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn v-if="helper === true" color="success" block v-on="{ ...dialog }">
        <v-icon small left>fa-plus</v-icon>
        Créer
      </v-btn>
      <v-btn v-else-if="id === null" text color="success" v-on="{ ...dialog }">
        <v-icon small left>fa-plus</v-icon>
        Planifier une préparation
      </v-btn>
      <v-btn
        v-else
        v-show="getIsAdmin"
        icon
        :small="!$vuetify.breakpoint.xsOnly"
        v-on="{ ...dialog }"
      >
        <v-icon :small="!$vuetify.breakpoint.xsOnly">fa-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <v-btn
            v-if="id !== null"
            small
            icon
            text
            @click="deleteItem"
            :disabled="loading"
          >
            <v-icon small>fa-trash</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <AutomaticPrepSlipFields
          v-show="!loading"
          ref="inputs"
          v-bind.sync="data"
          :valid.sync="valid"
        ></AutomaticPrepSlipFields>
        <v-progress-linear
          indeterminate
          color="primary"
          v-show="loading"
        ></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :outlined="$vuetify.breakpoint.xsOnly"
            :text="!$vuetify.breakpoint.xsOnly"
            @click="dialog = false"
            :disabled="loading"
          >
            Annuler
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
            color="success"
            :disabled="!valid || loading"
            @click="save"
          >
            Appliquer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import AutomaticPrepSlipFields from "./AutomaticPrepSlipFields";
import { mapGetters } from "vuex";
export default {
  name: "AutomaticPrepSlipEditor",
  components: {
    AutomaticPrepSlipFields
  },
  props: {
    id: {
      default: null
    },
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getIsAdmin"])
  },
  data() {
    return {
      loading: false,
      dialog: false,
      data: {
        fk_product: null,
        day: 0,
        quantity: 0
      },
      valid: false
    };
  },
  methods: {
    async getData() {
      if (this.id !== null) {
        try {
          this.loading = true;
          this.data = await api.retrieveAutomaticPreparationSlip(this.id);
        } finally {
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.id !== null) {
        try {
          this.loading = true;
          await api.patchAutomaticPreparationSlip(this.id, this.data);
          this.$emit("update");
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      } else {
        try {
          this.loading = true;
          const data = {
            ...this.data,
            store: this.getStoreId
          };
          await api.postAutomaticPreparationSlip(data);
          this.$emit("update");
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    },
    async deleteItem() {
      const allow = await this.$dialog.confirm({
        text: "Voulez-vous vraiment supprimer cette préparation automatique?",
        title: ""
      });
      if (allow) {
        try {
          this.loading = true;
          await api.deleteAutomaticPreparationSlip(this.id);
          this.$emit("update");
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.$refs.inputs.reset();
      } else {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
